import React, { useEffect, useRef, useState } from "react";
import { Alert, Typography } from "@mui/material";
import { api } from "../../../api/api";
import CatalogoEstruturado from "./CatalogoEstruturado";
import { criarEstruturaVazia, completarCatalogo } from "./modeloEstruturado";

async function requisitarCatalogo(url, options = {}) {
  const resposta = await fetch(url, { credentials: "include", ...options, headers: { "Content-Type": "application/json", ...options.headers } });
  const dados = await resposta.json().catch(() => ({}));
  if (!resposta.ok) throw new Error((Array.isArray(dados.message) ? dados.message.join(". ") : dados.message) || `Erro ao acessar o catálogo (${resposta.status}).`);
  return completarCatalogo(dados);
}
export default function CatalogoEnsino({ catalogoInicial, abrirGerenciamento = false }) {
  const [catalogo, setCatalogo] = useState(() => completarCatalogo(catalogoInicial || criarEstruturaVazia()));
  const [carregando, setCarregando] = useState(!catalogoInicial);
  const [erro, setErro] = useState("");
  const [pendente, setPendente] = useState(false);
  const bloqueio = useRef(false);
  useEffect(() => {
    if (catalogoInicial) return;
    let ativo = true;
    requisitarCatalogo(api.catalogoEnsino()).then((dados) => { if (ativo) setCatalogo(dados); })
      .catch((e) => { if (ativo) setErro(e.message); }).finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, [catalogoInicial]);
  const executar = async (metodo, tipo, item, id) => {
    if (bloqueio.current) throw new Error("Aguarde a conclusão da operação anterior.");
    bloqueio.current = true; setPendente(true);
    try {
      const url = id === undefined ? api.catalogoEnsinoCategoria(tipo) : api.catalogoEnsinoItem(tipo, id);
      const dados = item ? (({ id: _id, ...campos }) => campos)(item) : undefined;
      const atualizado = await requisitarCatalogo(url, { method: metodo, ...(dados ? { body: JSON.stringify(dados) } : {}) });
      setCatalogo(atualizado); return atualizado;
    } finally { bloqueio.current = false; setPendente(false); }
  };
  return carregando ? <Typography>Carregando catálogo...</Typography>
    : erro ? <Alert severity="error">Não foi possível carregar o catálogo: {erro}</Alert>
    : <CatalogoEstruturado catalogo={catalogo} abrirGerenciamento={abrirGerenciamento} operacaoPendente={pendente}
        onSave={(tipo, item, editando) => executar(editando ? "PATCH" : "POST", tipo, item, editando ? item.id : undefined)}
        onDelete={(tipo, id) => executar("DELETE", tipo, undefined, id)} />;
}
